import { useQuery } from "@apollo/client";
import { getEntityAuditLog } from "@src/util/query/audit.query";
import { Table } from "antd";
import dayjs from "dayjs";

export const EditDutyAuditLogTab = ({scheduleId})=>{
    const {data, loading} = useQuery(getEntityAuditLog,{
        variables:{
            entity: 'schedule' ,
            entityId: scheduleId,
        },
        skip: !scheduleId,
        fetchPolicy: 'network-only'
    });

    const columns = [
        {
            title: 'Origin',
            dataIndex: 'origin',

        },
        {
            title: 'Type',
            dataIndex: 'type',
            filters: [...new Set(data?.getEntityAuditLog?.response?.map((res) => res?.type).filter(Boolean))]
                .map((type) => ({text: type, value: type})),
            onFilter: (value, record) => record?.type === value,
        },
        {
            title: 'Punctuality',
            dataIndex: 'punctuality',
            filters: [...new Set(data?.getEntityAuditLog?.response?.map((res) => res?.punctuality).filter(Boolean))]
                .map((punctuality) => ({text: punctuality, value: punctuality})),
            onFilter: (value, record) => record?.punctuality === value,
            render: (punctuality) => punctuality
                ? <span style={{color: punctuality === 'Late' ? '#cf1322' : '#389e0d'}}>{punctuality}</span>
                : null,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (action) => <div style={{whiteSpace: 'pre-line'}}>{action}</div>,

        },

        {
            title: 'Action At',
            dataIndex: 'createdAt',

        }
    ]

    return(
          
        <div className="box-shadow border-radius">

            <div style={{padding:'16px'}}>
                    <div className='hr-info-title' style={{display:'flex', justifyContent:'space-between'}}>
                        Audit Logs
                        {/* <button className="drawer-outlined-btn" style={{padding:'5px 10px'}}> <FontAwesomeIcon icon={faFilePdf}/> Export Pdf</button> */}
                    </div>
            </div>

            <Table
                className="curvedTable"
                loading={loading}
                dataSource={data?.getEntityAuditLog?.response?.map((res)=> ({...res, createdAt: dayjs(res?.createdAt)?.format("ddd DD MMM YYYY HH:mm")}))}
                columns={columns}
            />

        </div>
    );
}